import { render, staticRenderFns } from "./SimpleVerticalIndicator.vue?vue&type=template&id=480c63ea&scoped=true"
import script from "./SimpleVerticalIndicator.vue?vue&type=script&lang=js"
export * from "./SimpleVerticalIndicator.vue?vue&type=script&lang=js"
import style0 from "./SimpleVerticalIndicator.vue?vue&type=style&index=0&id=480c63ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480c63ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('480c63ea')) {
      api.createRecord('480c63ea', component.options)
    } else {
      api.reload('480c63ea', component.options)
    }
    module.hot.accept("./SimpleVerticalIndicator.vue?vue&type=template&id=480c63ea&scoped=true", function () {
      api.rerender('480c63ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-wizard-kyc/indicators/SimpleVerticalIndicator.vue"
export default component.exports